<app-breadcrumb [title]="'Registrar'" [items]="['Mantenimiento']" [active_item]="'Registrar'">
</app-breadcrumb>

<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>REGISTRAR MANTENIMIENTOS</strong></h5>
  </div>

  <div class="card-body">

    <form [formGroup]="formMantenimiento">
      <div class="row g-3 mb-3">
        <div class="col-md-3">
          <label class="form-label" for="finicial"><strong>Fecha de Realización</strong> *:</label>
          <div class="input-group input-group-sm">
            <input #inputFecha id="finicial" formControlName="fecha" type="date"
              class="form-control form-control-lg fs-14" name="fecha" [max]="maxDate" onkeydown="return false;" />
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="vehiculos"><strong>Placa</strong> *:</label>
          <ng-select #inputPlaca id="vehiculos" formControlName="placa" [items]="vehiculos" bindLabel="placa"
            bindValue="placa" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
                        <ng-template ng-label-tmp let-item="item">
              <span class="text-uppercase">
                {{ item.placa }} 
              </span>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <span class="text-uppercase">
                {{ item.placa }} 
              </span>
            </ng-template>
          </ng-select>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="ffinal"><strong>Kilometraje</strong> *:</label>
          <input #inputKm id="finicial" formControlName="km" type="number" name="" class="form-control"
            placeholder="Ingrese el kilometraje actual" />
        </div>

        <div class="col-md-3">
          <label class="form-label" for="objeto"><strong>Tipo de Mantenimiento</strong> *:</label>
          <ng-select #inputtipo id="objeto" formControlName="idTipoMantenimiento" [items]="TipoMantenimiento" bindLabel="nombre"
            bindValue="id" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
          </ng-select>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="viaje"><strong>Proveedor o Taller Mecánico</strong> *:</label>
          <div class="input-group">
            <div class="form-control p-0 border-0">
              <ng-select #inputTaller placeholder="Selecciona una opción" formControlName="taller"
                [items]="empresaTaller" bindLabel="nombre" bindValue="nombre" class="js-example-placeholder-multiple">
              </ng-select>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal2)"
              ngbTooltip="Crear empresa contratista">
              <i class="icofont icofont-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label"><strong>Conductor</strong> *:</label>
          <ng-select #inputConductor formControlName="conductor" [items]="conductor" bindValue="cedula"
            [bindLabel]="'cedula'" placeholder="Selecciona una opción" [searchFn]="customSearchFn"
            class="js-example-placeholder-multiple">
            <ng-template ng-label-tmp let-item="item">
              <span class="text-uppercase">
                {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                item.seapellidos }}
              </span>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <span class="text-uppercase">
                {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                item.seapellidos }}
              </span>
            </ng-template>
          </ng-select>

        </div>

        <div class="col-md-3">
          <label class="form-label"><strong>Número de Factura</strong> *:</label>
          <input #inputFactura class="form-control" formControlName="factura" type="number"
            placeholder="Ingrese el número de factura" />
        </div>

        <div class="col-md-3">
          <label class="form-label"><strong>Forma de Pago</strong> *:</label>
          <ng-select #inputForma placeholder="Selecciona una opción" formControlName="idFormaPago" [items]="formapago"
            bindLabel="descripcion" bindValue="id">
          </ng-select>
        </div>

        <div class="col-md-3">
          <label class="form-label"><strong>Tipo de Acción</strong> *:</label>
          <ng-select #inputAccion [items]="tipoaccion" bindLabel="descripcion" formControlName="idAccion"
            bindValue="id" placeholder="Selecciona una opción">
          </ng-select>
        </div>

        <div class="col-md-3">
          <label class="form-label"><strong>Valor Pagado</strong> *:</label>
          <input #inputVrPagos class="form-control" type="number"
             formControlName="vrpagos" placeholder="Ingrese el valor pagado" />
        </div>

        <div class="col-md-6">
          <label class="form-label"><strong>Servicio Realizado</strong> *:</label>
          <div class="input-group">
            <div class="form-control p-0 border-0">
              <ng-select #inputServicio formControlName="servicio" [items]="servicioRealizado"
                bindLabel="tipo_de_mantenimiento" bindValue="id" placeholder="Selecciona una opción"
                class="js-example-placeholder-multiple">

                <ng-template ng-label-tmp let-item="item">
                  {{ item?.tipo_de_mantenimiento ? item.tipo_de_mantenimiento.toUpperCase() : '' }}
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  {{ item?.tipo_de_mantenimiento ? item.tipo_de_mantenimiento.toUpperCase() : '' }}
                </ng-template>
              </ng-select>

            </div>
            <button type="button" class="btn btn-primary btn-sm" ngbTooltip="Crear Servicio"
              (click)="openModalServicioRealizado(myModal)">
              <i class="icofont icofont-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-md-12">
          <label><strong>Observaciones:</strong></label>
          <textarea class="form-control" id="observaciones" rows="2" formControlName="observacion"></textarea>
        </div>
      </div>
      <div class="row mt-4">
        <!-- PANEL IZQUIERDO: SOPORTE DE FACTURA -->
      <div class="col-md-6">
        <ngb-accordion [closeOthers]="false" activeIds="static-1">
          <ngb-panel id="static-1">
            <ng-template ngbPanelTitle>
              <i class="fa fa-file-pdf"></i>
              <span class="ms-2"><strong>SOPORTE DE FACTURA</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <form [formGroup]="formDocumentos">
                <div class="card shadow-sm">
                  <div class="card-body text-center">
                    <!-- Input oculto -->
                    <input type="file" accept=".pdf" class="d-none" (change)="onFileChange($event, 1)"
                      id="fileInput1" />

                    <!-- Área visible -->
                    <div class="dropzone-label border border-primary rounded py-4 cursor-pointer"
                      (click)="abrirInput(1)">
                      <ng-container *ngIf="dropzones[0].files.length > 0; else placeholderFactura">
                        <div *ngFor="let file of dropzones[0].files; let i = index" class="position-relative mb-3">
                          <button class="btn btn-outline-danger  btn-sm position-absolute top-0 end-0 m-1"
                            (click)="removeFile(1, i); $event.stopPropagation(); $event.preventDefault()">✖</button>
                          <iframe *ngIf="file.type === 'application/pdf'" [src]="file.preview" width="100%" height="700"
                            style="border: 1px solid #ccc;margin-top: 45px;"></iframe>
                          <small class="d-block text-muted text-truncate mt-1" [title]="file.name">{{ file.name
                            }}</small>
                        </div>
                      </ng-container>
                      <ng-template #placeholderFactura>
                        <i class="bi bi-upload fs-1 text-dark mb-2"></i>
                        <p class="fw-semibold text-dark">Haz clic o arrastra para cargar SOPORTE DE FACTURA</p>
                      </ng-template>
                    </div>

                    <!-- Mensajes -->
                    <div *ngIf="dropzones[0].error" class="alert alert-danger mt-2">{{ dropzones[0].error }}</div>
                    <div *ngIf="dropzones[0].eliminado" class="alert alert-warning mt-2">Archivo eliminado correctamente
                    </div>
                  </div>
                </div>
              </form>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>

      <!-- PANEL DERECHO: SOPORTE DE MANTENIMIENTOS -->
      <div class="col-md-6">
        <ngb-accordion [closeOthers]="false" activeIds="static-2">
          <ngb-panel id="static-2">
            <ng-template ngbPanelTitle>
              <i class="fa fa-images"></i>
              <span class="ms-2"><strong>SOPORTE DE MANTENIMIENTOS</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <form [formGroup]="formDocumentos">
                <div class="card shadow-sm">
                  <div class="card-body text-center">
                    <!-- Input oculto -->
                    <input type="file" multiple accept="image/*" class="d-none" (change)="onFileChange($event, 2)"
                      id="fileInput2" />

                    <!-- Área visible -->
                    <div class="dropzone-label border border-primary rounded py-4 cursor-pointer"
                      (click)="abrirInput(2)">
                      <ng-container *ngIf="dropzones[1].files.length > 0; else placeholderMantenimientos">
                        <div class="d-flex flex-wrap justify-content-center gap-3">
                          <div *ngFor="let file of dropzones[1].files; let i = index"
                            class="position-relative text-center">
                            <img *ngIf="file.type.startsWith('image/')" [src]="file.preview" class="img-thumbnail mb-2"
                              style="width: 150px; height: auto;" />
                           <button 
                            class="btn btn-danger btn-xs rounded-circle position-absolute top-0 end-0"
                            style="width: 22px; height: 22px; font-size: 12px; margin: 6px;"
                            (click)="removeFile(2, i); $event.stopPropagation(); $event.preventDefault()">
                            ✖
                          </button>
                            <small class="d-block text-muted text-truncate" [title]="file.name">{{ file.name }}</small>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #placeholderMantenimientos>
                        <i class="bi bi-upload fs-1 text-dark mb-2"></i>
                        <p class="fw-semibold text-dark">Haz clic o arrastra para cargar SOPORTE DE MANTENIMIENTOS</p>
                      </ng-template>
                    </div>

                    <!-- Mensajes -->
                    <div *ngIf="dropzones[1].error" class="alert alert-danger mt-2">{{ dropzones[1].error }}</div>
                    <div *ngIf="dropzones[1].eliminado" class="alert alert-warning mt-2">Archivo eliminado correctamente
                    </div>
                  </div>
                </div>
              </form>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
    
    </form>

    <div class="d-flex justify-content-center gap-3 mt-3">
      <button type="button" placement="top" ngbTooltip="Agregar Mantenimiento" class="btn btn-primary"
        (click)="agregarMantenimiento()">
        <i class="icon-plus"></i> <strong>AGREGAR MANTENIMIENTO</strong>
      </button>
    </div>

    <div class="card-body custom-datatable noscroll" *ngIf="mantenimientos.length > 0">
      <div class="custom-datatable table-responsive">
        <form [formGroup]="formMantenimientos">
          <table class="table table-hover table-bordered" id="tblMantenimiento">
            <thead class="bg-primary">
              <tr>
                <th class="text-center"><strong>PLACA</strong></th>
                <th class="text-center"><strong>KM</strong></th>
                <th class="text-center"><strong>TIPO DE MANTENIMIENTO</strong></th>
                <th class="text-center"><strong>PROVEEDOR</strong></th>
                <th class="text-center"><strong>SERVICIO REALIZADO</strong></th>
                <th class="text-center"><strong>TIPO DE ACCIÓN</strong></th>
                <th class="text-center"><strong>NÚMERO DE FACTURA</strong></th>
                <th class="text-center"><strong>VALOR</strong></th>
                <th class="text-center"><strong>FORMA DE PAGO</strong></th>
                <th class="text-center"><strong>OBSERVACION</strong></th>
                <th class="text-center"><strong>OPCIONES</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of mantenimientos; let i = index">
                <td class="text-center">{{ item.placa }}</td>
                <td class="text-center">{{ item.km }}</td>
                <td class="text-center">{{ item.tipo }}</td>
                <td class="text-center">{{ item.taller }}</td>
                <td class="text-center">{{ item.servicio | uppercase }}</td>
                <td class="text-center">{{ item.accion }}</td>
                <td class="text-center">{{ item.factura }}</td>
                <td class="text-center">{{ item.vrpagos }}</td>
                <td class="text-center">{{ item.forma }}</td>
                <td class="text-center">{{ item.observacion }}</td>
                <td>
                  <div class="action text-center">
                    <ul class="list-inline">
                      <li class="delete">
                        <a href="javascript:void(0)" (click)="eliminarMantenimiento(i)"><i class="icon-trash"></i></a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
        <div class="d-flex justify-content-center gap-3 mt-3">
          <button class="btn btn-primary d-flex align-items-center" type="button" (click)="guardarMantenimiento()">
            GUARDAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #myModal let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>AGREGAR TIPOS DE MANTENIMIENTOS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formServicio">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label><strong>Sistema *:</strong></label>
            <ng-select [items]="sistemaMantenimiento" formControlName="sistema" bindLabel="descripcion"
              bindValue="descripcion" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label><strong>Parte *:</strong></label>
            <ng-select [items]="parteMantenimiento" formControlName="parte" bindLabel="descripcion"
              bindValue="descripcion" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label><strong>Tipo de Mantenimiento *:</strong></label>
            <input type="text" class="form-control" formControlName="tipo_de_mantenimiento" #inputTipo />
          </div>

        </div>
      </form>

    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarServicio(modal)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal2 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formEmpresa">
        <!-- Inputs antes de la tabla -->
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
            <input class="form-control" id="nit" type="number" placeholder="Ingrese CC o NIT" formControlName="nit"
               (input)="limitarLongitud($event, 10)" [class.is-invalid]="formEmpresa.get('nit')?.invalid && (formEmpresa.get('nit')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('nit')?.invalid && (formEmpresa.get('nit')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un número de documento.
            </div>

          </div>


          <div class="col-md-3">
            <label class="form-label" for="digito">
              <strong>Digito de Verificacción *:</strong></label>
            <input #inputCodigo class="form-control" id="digito" type="number" required
              placeholder="Ingrese el dígito de verificación" formControlName="digito"
              [class.is-invalid]="formEmpresa.get('digito')?.invalid && (formEmpresa.get('digito')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('digito')?.invalid && (formEmpresa.get('digito')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un digito de verificación.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
            <input #inputNombre class="form-control" id="nombre" type="text"
              placeholder="Ingrese el nombre o razon social" required formControlName="nombre"
              [class.is-invalid]="formEmpresa.get('nombre')?.invalid && (formEmpresa.get('nombre')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('nombre')?.invalid && (formEmpresa.get('nombre')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un nombre o razón social.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="direccion">
             <strong>Dirección *:</strong></label>
            <input #inputDireccion class="form-control" id="direccion" type="text" required
              placeholder="Ingresa una dirección" formControlName="direccion"
              [class.is-invalid]="formEmpresa.get('direccion')?.invalid && (formEmpresa.get('direccion')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('direccion')?.invalid && (formEmpresa.get('direccion')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa una dirección.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label"><strong>Ciudad *:</strong></label>
            <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
              placeholder="Selecciona una opción" formControlName="ciudad">
            </ng-select>
            <div *ngIf="formEmpresa.get('ciudad')?.invalid && (formEmpresa.get('ciudad')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa una ciudad.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="telefono"><strong>Teléfono Fijo:</strong></label>
            <input class="form-control" id="telefono" type="number" inputmode="numeric"  placeholder="Ingresa el teléfono fijo" formControlName="telefono"
              (input)="limitarLongitud($event, 10)" />
            <div *ngIf="formEmpresa.get('telefono')?.invalid && formEmpresa.get('telefono')?.touched"
              class="invalid-feedback">
              El teléfono fijo debe tener 10 dígitos.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="celular"><strong>Teléfono Celular *:</strong></label>
            <input #inputCelular class="form-control" id="celular" type="number"
               placeholder="Ingresa el teléfono celular" formControlName="celular"
              (input)="limitarLongitud($event, 10)"
              [class.is-invalid]="formEmpresa.get('celular')?.invalid && (formEmpresa.get('celular')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('celular')?.invalid && (formEmpresa.get('celular')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un número de celular de 10 dígitos.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="email">
              <strong>Correo Electrónico *:</strong></label>
            <input #inputEmail class="form-control" id="email" type="text" required
              placeholder="Ingresa un correo valido" formControlName="email"
              [class.is-invalid]="formEmpresa.get('email')?.invalid && (formEmpresa.get('email')?.touched || validate)" />
            <div *ngIf="formEmpresa.get('email')?.invalid && (formEmpresa.get('email')?.touched || validate)"
              class="invalid-feedback">
              Por favor, ingresa un correo electronico.
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="mb-3">
              <label><strong>Observaciones:</strong></label>
              <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>

        </div>

      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>